import { FlashMessageProcessorFactory } from 'src/com/sixdee/crbtportal/core/processorfactory/flashmessageprocessorfactory';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { FlashSubscriptionDetailsRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsrequest';
import { FlashSubscriptionDetailsResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsresponse';
import { SubscribeUnSubscribeFlashMessageRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/subscribeunsubscribe/subscribeunsubscribeflashmessagesrequest';
import { SubscribeUnSubscribeFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/subscribeunsubscribe/subscribeunsubscribeflashmessagesresponse';
import { PlayPauseFlashMessageRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/playpause/playpauseflashmessagesrequest';
import { PlayPauseFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/playpause/playpuaseflashmessagesresponse';
import { DeleteFlashMessageRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/delete/deleteflashmessagesrequest';
import { DeleteFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/delete/deleteflashmessagesresponse';
import { GetFlashMessageRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getflashmessages/getflashmessagesrequest';
import { GetFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getflashmessages/getflashmessagesresponse';
import { DeleteDedicateFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/deletededicate/deletededicateflashmessagesresponse';
import { GetDedicateFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getdedicateflashmessages/getdedicateflashmessagesresponse';
import { DedicateFlashDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';
import { DeleteDedicateFlashMessageRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/deletededicate/deletededicateflashmessagesrequest';
import { GetFlashStatusResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getflashstatus/getflashstatusresponse';
import { GetFlashStatusRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getflashstatus/getflashstatusrequest';


export interface FlashMessageSubscriptionDetailsAPIModel extends APIModel
{
    getSubscriberDetails(): void;
    unsubscribe(): void;
    changeStatus(status: boolean): void;
    deleteFlashMessage(): void;
    getFlashMessage(msisdn: string): void;
    deleteDedicateFlashMessage(flashDto: DedicateFlashDto): void;
    getDedicateFlashDetails(): void;
    getFlashStatus(): void;
}

export class FlashMessageSubscriptionDetailsAPIModelImpl extends APIModelImpl implements FlashMessageSubscriptionDetailsAPIModel
{
    private flashMessageProcessor: FlashMessageProcessorFactory;
   
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.flashMessageProcessor = this.getAPIProcesssorFactory().getFlashMessageProcessorFactory();
    }

    deleteFlashMessage(): void {
      this.flashMessageProcessor.deleteFlashMessageAPIProcessor()
      .success((subscriberValidationResponse: DeleteFlashMessageResponse) => {
        this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
        subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .failure((subscriberValidationResponse: DeleteFlashMessageResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new DeleteFlashMessageRequestImpl(this.getContext().getUserContext().getMsisdn()));
    }

    deleteDedicateFlashMessage(flashDto: DedicateFlashDto): void 
    {
      this.flashMessageProcessor.deleteDedicateFlashAPIProcessor()
      .success((subscriberValidationResponse: DeleteDedicateFlashMessageResponse) => {
        this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
        subscriberValidationResponse.getDescription(), flashDto);
      })
      .failure((subscriberValidationResponse: DeleteDedicateFlashMessageResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new DeleteDedicateFlashMessageRequestImpl(flashDto.getId(), 
      this.getContext().getUserContext().getMsisdn()));
    }

    getSubscriberDetails(): void
    {
      this.flashMessageProcessor.getSubscriptionAPIProcessor()
      .success((subscriberValidationResponse: FlashSubscriptionDetailsResponse) => 
      {
        console.log("success: " + JSON.stringify(subscriberValidationResponse));
        this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
        subscriberValidationResponse.getDescription(), subscriberValidationResponse.getFlashSubscriptionDetailsResponseDto());
      })
      .failure((subscriberValidationResponse: FlashSubscriptionDetailsResponse) => 
      {
        console.log("failure: " + JSON.stringify(subscriberValidationResponse));
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new FlashSubscriptionDetailsRequestImpl(this.getContext().getUserContext().getMsisdn()));
    }

    getFlashStatus(): void
    {
      this.flashMessageProcessor.getFlashStatusAPIProcessor()
      .success((subscriberValidationResponse: GetFlashStatusResponse) => 
      {
        console.log("success: " + JSON.stringify(subscriberValidationResponse));
        this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
        subscriberValidationResponse.getDescription(), subscriberValidationResponse.getFlashStatus());
      })
      .failure((subscriberValidationResponse: GetFlashStatusResponse) => 
      {
        console.log("failure: " + JSON.stringify(subscriberValidationResponse));
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new GetFlashStatusRequestImpl(this.getContext().getUserContext().getMsisdn()));
    }

    getDedicateFlashDetails(): void
    {
      this.flashMessageProcessor.getDedicateFlashDetailsAPIProcessor()
      .success((getFlashMessageResponse: GetDedicateFlashMessageResponse) => 
      {
        console.log("success: " + JSON.stringify(getFlashMessageResponse));
        
        this.getAPIModelHandler().onSuccess(getFlashMessageResponse.getAPIFeature(),
        getFlashMessageResponse.getDescription(), getFlashMessageResponse.getDedicateFlashDtoDtos());
      })
      .failure((subscriberValidationResponse: GetDedicateFlashMessageResponse) => 
      {
        console.log("failure: " + JSON.stringify(subscriberValidationResponse));
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new FlashSubscriptionDetailsRequestImpl(this.getContext().getUserContext().getMsisdn()));
    }

    changeStatus(status: boolean): void
    {
      console.log("this.state.isStatusActive: " + status);
      this.flashMessageProcessor.playpauseFlashMessageAPIProcessor()
      .success((subscriberValidationResponse: PlayPauseFlashMessageResponse) => {
        this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
        subscriberValidationResponse.getDescription(), status);
      })
      .failure((subscriberValidationResponse: PlayPauseFlashMessageResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new PlayPauseFlashMessageRequestImpl(this.getContext().getUserContext().getMsisdn(), status ? "A" : "D"));
    }


    unsubscribe(): void
    {
      this.flashMessageProcessor.subscribeunsubscrbeFlashMessageAPIProcessor()
      .success((subscriberValidationResponse: SubscribeUnSubscribeFlashMessageResponse) => {
        this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
        subscriberValidationResponse.getDescription(), subscriberValidationResponse.getFlashMessageResponseDtos());
      })
      .failure((subscriberValidationResponse: SubscribeUnSubscribeFlashMessageResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new SubscribeUnSubscribeFlashMessageRequestImpl(this.getContext().getUserContext().getMsisdn()));
    }

    getFlashMessage(msisdn: string): void 
    {
        this.flashMessageProcessor.getFlashMessageAPIProcessor()
        .success((getFlashMessageResponse: GetFlashMessageResponse)=>
                  {
                     this.getAPIModelHandler().onSuccess(getFlashMessageResponse.getAPIFeature(), 
                     getFlashMessageResponse.getDescription(), getFlashMessageResponse.getFlashMessageResponseDtos()); 
                  })
                  .failure((getFlashMessageResponse : GetFlashMessageResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(getFlashMessageResponse.getAPIFeature(), 
                      getFlashMessageResponse.getDescription(), undefined);
                    
                  })
                  .execute(new GetFlashMessageRequestImpl(msisdn));

    }
    // let featuredCategoryDto = new FeaturedCategoryDtoImpl();
    // featuredCategoryDto.setIdentifier(this.getContext().getResources().getString(Strings.default_flash_message));
    // featuredCategoryDto.setTitle(this.getContext().getResources().getString(Strings.default_flash_message));
    // featuredCategoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn() === "" ? "0" : this.getContext().getUserContext().getMsisdn());
    // featuredCategoryDto.setLanguage(this.getContext().getUserContext().getLanguage());

    // let listOftones = [];
    // let toneDto1 = new ToneDtoImpl();
    // toneDto1.setId("1");
    // toneDto1.setToneName("23");
    // toneDto1.setArtistName("jhg");
    // listOftones.push(toneDto1);

    // featuredCategoryDto.setListOfTones(listOftones);

    // this.getAPIModelHandler().onSuccess(APIFeatures.FLASH_MESSAGE, 
    //              "", featuredCategoryDto); 
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagesubscriptiondetails/flashmessagesubscriptiondetailsapimodel.tsx